import {Route, Routes} from "react-router-dom";
import LearningCatalog from "./LearningCatalog";
import CourseDetail from "./CourseDetail";
import LessonView from "./LessonView";

// Index of the learning system. Handles nested routes:
//   /learning           -> catalog
//   /learning/:slug     -> course detail
//   /learning/:slug/:lessonId -> lesson view
function LearningIndex() {
  return (
    <Routes>
      <Route index element={<LearningCatalog />} />
      <Route path={":slug"} element={<CourseDetail />} />
      <Route path={":slug/:lessonId"} element={<LessonView />} />
    </Routes>
  );
}

export default LearningIndex;
